import { render, staticRenderFns } from "./HotelingT2.vue?vue&type=template&id=588fddce&"
import script from "./HotelingT2.script.js?vue&type=script&lang=js&"
export * from "./HotelingT2.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports